// ABOUTME: Client-side helper that records user activity events which have no database trigger.
// ABOUTME: Used for sign-in/sign-out, password changes and vocabulary trainer sessions.
import { supabase } from '@/integrations/supabase/client';

export type ActivityCategory = 'learning' | 'account' | 'billing' | 'messaging' | 'content';

/**
 * Writes a single activity entry for the given user. Never throws: a failed log
 * must not interrupt the user flow it was recorded from.
 */
export async function logUserActivity(
  userId: string | null | undefined,
  category: ActivityCategory,
  eventType: string,
  details: Record<string, unknown> = {},
  target?: { table?: string; id?: string },
): Promise<void> {
  if (!userId) return;
  try {
    const { error } = await supabase.from('user_activity_log').insert({
      user_id: userId,
      category,
      event_type: eventType,
      target_table: target?.table ?? null,
      target_id: target?.id ?? null,
      details: details as never,
    });
    if (error) {
      console.warn('[user-activity] failed to log event', eventType, error.message);
    }
  } catch (err) {
    console.warn('[user-activity] unexpected error logging event', eventType, err);
  }
}
